import { BrowserModule } from '@angular/platform-browser';
import { DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AuthModule } from './auth/auth.module';
import { SharedModule } from './shared/shared.module';
import { AppComponent } from './app.component';
import { CsProjectsModule } from './cs-projects/cs-projects.module';
import { CsBuildupModule } from './cs-buildup/cs-buildup.module';

import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { HomeComponent } from './home/home.component';
import { ImpressumComponent } from './impressum/impressum.component';

registerLocaleData(localeDe);

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ImpressumComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AuthModule,
    SharedModule,
    CsProjectsModule,
    CsBuildupModule
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'de-DE' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' }
   ],
  bootstrap: [AppComponent]
})
export class AppModule { }
